
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">
    {{ company?.fullname }}
  </h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="company">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!company.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  
  <div *ngIf="mode === 'view'" class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="company">

    <div class="column">

      <div *ngIf="mode === 'edit' || mode === 'new'" class="panel">
        <h2>Société</h2>

        <div class="form-group">
          <label for="name">Nom</label>
          <input #nameInput id="name" type="text" placeholder="" [formControl]="name" maxlength="200"/>
          <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
        </div>

        <div class="form-group">
          <label for="rcs">RCS</label>
          <input id="rcs" name="rcs" type="text" placeholder="" [(ngModel)]="company.rcs" maxlength="200"/>
        </div>

      </div>

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Liste des registres</h2>
      
        <div class="btn-toolbar">
          <a class="btn btn-small btn-gray" [routerLink]="['new']" title="Ajouter un nouveau registre">
            <t-icon name="add"></t-icon>
            <span class="text">Ajouter</span>
          </a>
        </div>
      
        <table *ngIf="company.ledgers.length > 0">
          <tbody>
            <tr *ngFor="let ledger of company.ledgers; index as index" (click)="showLedger(ledger)">
              <td>{{ ledger.name }}</td>
              <td style="font-size: 11px;">{{ ledger.signed ? '[Avec documents signés]' : '' }}</td>
              <td style="width: 50px;" class="actions">
                <a class="action-btn">
                  <t-icon name="arrow_forward"></t-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="empty-table compact" *ngIf="company.ledgers.length === 0">
          <p>Aucun registre dans cette société</p>
        </div>
      
      </div>
      
    </div>
    
    <div class="column">

      <dl-authorization-list *ngIf="mode === 'view'" [company]="company" title="Comptes clients autorisés"></dl-authorization-list>

    </div>

  </div>
</form>